export default "__VITE_ASSET__BrNkoHtg__"